import { useCallback, useEffect, useState } from "react";

// components
import NoCard from "./noCard";
import AddPayment from "./addPayment";
import { getUserId } from "../../../setup/auth/oidc";
import { getBankDetails } from "../../../setup/api/services/bank";
import { IBankDetailsResponseData } from "../../../setup/api/services/bank/model";

const Payment = () => {
  const userId = getUserId();
  const [showBank, setShowBank] = useState<boolean>(false);
  const [bank, setBank] = useState<
    IBankDetailsResponseData["bank"] | undefined
  >(undefined);

  const getBank = useCallback(async () => {
    try {
      const response = await getBankDetails();
      if (response?.data) setBank(response?.data[0]?.bank);
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    getBank();
  }, [getBank]);

  if (showBank || bank) {
    return <AddPayment bank={bank} />;
  }

  return <NoCard handleClick={() => setShowBank(!showBank)} />;
};

export default Payment;
